import { atomWithStorage } from "jotai/utils";

import { LooseObject } from "~/utils/Types";

const initialValue = undefined;

export const userConfigAtom = atomWithStorage<LooseObject | undefined>(
  "userConfig",
  initialValue,
  undefined,
  { getOnInit: true },
);
